<template>
    <div>
        <div class="flex items-center justify-between">
            <breadcrumbs>Blogrubrieken</breadcrumbs>
            <link-button :href="route('admin.blogcategories.create')" icon="plus" class="bg-white">Nieuwe rubriek</link-button>
        </div>

        <div class="flex justify-between items-center">
            <h1 class="text-5xl text-teal-800">Blogrubrieken</h1>
        </div>

        <div class="flex justify-between items-center mb-5">
            <div class="flex flex-col">
                <search-filter v-model="form.search" class="w-full max-w-sm mr-4" @reset="reset" @input="submitSearch">
                    <!-- <label class="block text-grey-darkest">Categorie:</label> -->
                    <!-- <select v-model="form.category" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option v-for="(name, slug) in categories" :key="slug" :value="slug">{{ name }}</option>
                    </select> -->
                </search-filter>

                <active-filters :filters="filters" @remove-filter="removeFilter" />
            </div>

            <num-results name="blogcategories"
                         :from="blogcategories.from"
                         :to="blogcategories.to"
                         :total="blogcategories.total"
            />

            <input type="hidden" v-model="form.orderBy" />
            <input type="hidden" v-model="form.sortOrder" />
        </div>

        <p v-if="!blogcategories.data.length">Er zijn geen categorieeen gevonden.</p>

        <table v-else class="w-full whitespace-no-wrap bg-white rounded">
            <tr class="text-teal-800 font-bold">
                <td class="px-3" width="100">
                    <a href @click.prevent="sort('id')" class="hover:underline"> ID<sort-icon col="id" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                </td>

                <td class="px-3 py-3">
                    <a href @click.prevent="sort('name')" class="hover:underline"> Name<sort-icon col="name" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                </td>

                <td class="px-3 py-3r" width="60">
                    <a href @click.prevent="sort('blogs_count')" class="hover:underline">
                        Blogs<sort-icon col="blogs_count" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                    </a>
                </td>

                <td class="px-3 py-3" width="160">
                    <a href @click.prevent="sort('created_at')" class="hover:underline">
                        <i class="fal fa-calendar-plus mr-1"></i>Created
                        <sort-icon col="created_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                    </a>
                </td>
            </tr>

            <tr
                v-for="(tag, index) in blogcategories.data"
                :key="blogcategories.id"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="{ 'bg-teal-100': !(index % 2), 'text-gray-500': tag.deleted_at }"
            >
                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.blogcategories.show', tag.id)" tabindex="-1">
                        {{ tag.id }}
                    </inertia-link>
                </td>

                <td class="border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.blogcategories.show', tag.id)">
                        {{ tag.name | truncate(50) }}
                    </inertia-link>
                </td>

                <td class="border-t text-center">
                    <inertia-link class="py-4 focus:text-teal-800 truncate" :href="route('admin.tags.show', tag.id)">
                        {{ tag.blogs_count }}
                    </inertia-link>
                </td>

                <td class="border-t">
                    <inertia-link class="py-4 flex items-center" :href="route('admin.blogcategories.show', tag.id)" tabindex="-1">
                        <div v-if="tag.created_at">
                            {{ moment(tag.created_at).format("DD-MM-YYYY") }}
                        </div>
                    </inertia-link>
                </td>
                <td class="text-right pr-5 border-t">
                    <div v-if="!tag.deleted_at">
                        <link-button :href="route('admin.blogcategories.edit', tag.id)" icon="pencil" class="hover:bg-white"></link-button>
                        <!-- <simple-button icon="trash" class="hover:bg-red-600 hover:text-white" @click="deleteBlog(tag)"></simple-button> -->
                    </div>
                </td>
            </tr>
        </table>

        <pagination :links="blogcategories.links" />
    </div>
</template>

<script>
import _ from "lodash";
import Layout from "@/admin/Shared/Layout";
import SortIcon from "@/admin/Shared/SortIcon";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Pagination from "@/admin/Shared/Pagination";
import { Inertia } from "@inertiajs/inertia";
import SearchFilter from "@/admin/Shared/SearchFilter";
import ToggleActiveIcon from "@/admin/Shared/ToggleActiveIcon";
import ActiveFilters from "@/admin/Shared/ActiveFilters";
import NumResults from "@/admin/Shared/NumResults";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";

export default {
    metaInfo: { title: "Blogrubriek" },

    layout: Layout,

    mixins: [Helpers],

    components: {
        Pagination,
        SearchFilter,
        ActiveFilters,
        SortIcon,
        ActiveToggle: ToggleActiveIcon,
        NumResults,
        Breadcrumbs,
        LinkButton
    },

    props: {
        blogcategories: Object,
        paginationInfo: Object,
        filters: Object,
        categories: Object
    },
    data() {
        return {
            form: {
                trashed: this.filters.trashed,
                category: this.filters.category,
                search: this.filters.search,
                orderBy: this.filters.orderBy,
                sortOrder: this.filters.sortOrder
            }
        };
    },
    methods: {
        reloadData() {
            let queryParams = _.pickBy(this.form);
            this.$inertia.replace(this.route("admin.blogcategories.index", Object.keys(queryParams).length ? queryParams : { remember: "forget" }));
        },

        sort(col) {
            this.form.sortOrder = this.getNewSortOrder(col, this.form.orderBy, this.form.sortOrder);
            this.form.orderBy = col;
            this.reloadData();
        },

        submitSearch: _.debounce(function() {
            this.reloadData();
        }, 250),

        reset() {
            this.form = _.mapValues(this.form, () => null);
            this.reloadData();
        },

        removeFilter(filterName) {
            this.form[filterName] = null;
            this.reloadData();
        }
    }
};
</script>
